import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import { setRoutingDestination } from 'src/store/common-slices/setRoutingDestinationSlice';
import { SetRoutingDestinationInput } from 'src/models/setRoutingDestination';
import AssignRoutingModal from './AssignRoutingModal';

const mapStateToProps = (state: RootState) => ({
    uiAlertState: state.UI.alertState,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    setRoutingDestination: (input: SetRoutingDestinationInput) => dispatch(setRoutingDestination(input)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignRoutingModal);
